export const avantGardeBold = {
  fontFamily: 'itc-avant-garde-gothic-pro, sans-serif',
  fontWeight: 700,
  fontStyle: 'normal'
};

export const avantGarde = {
  fontFamily: 'itc-avant-garde-gothic-pro, sans-serif',
  fontWeight: 300,
  fontStyle: 'normal'
};

export const americanTypewriterBold = {
  fontFamily: 'itc-american-typewriter, serif',
  fontWeight: 700,
  fontStyle: 'normal'
};

export const americanTypewriter = {
  fontFamily: 'itc-american-typewriter, serif',
  fontWeight: 500,
  fontStyle: 'normal'
};
